export default "__VITE_ASSET__DiJ5PzoQ__"